import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Row, Col, Container, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import swal from 'sweetalert2';
import Header from '../../Components/PageComponent/Layout/Header';
import Footer from '../../Components/PageComponent/Layout/Footer';
import FormInput from '../../Components/FormInput';

import { login, verifyOtp, resendOtp, sendOtp, changePassword, } from '../../redux/actions/AuthActions';
import LogoDark from "../../assets/images/logo-dark.png";
import LogoLight from "../../assets/images/logo-light.png";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { AuthReducer: { loading, otpVerifiedStatus, otpLoading, errors: reduxErrors, changedPasswordStatus } } = useSelector(state => state);

    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState('');
    const [formData, setFormData] = useState({
        mobile: '',
        password: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const [isOtpSent, setIsOtpSent] = useState(false);
    useEffect(() => {
        if (otpVerifiedStatus && isOtpSent) {
            setStep(3);
        }
    }, [otpVerifiedStatus]);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const selectMobileHandler = (e) => {
        const { value } = e.target;
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue.length <= 10) {
            setFormData(prev => ({ ...prev, mobile: numericValue }));
        }
    };

    const handleSendOtp = () => {
        if (formData.mobile.length !== 10) {
            setErrors({ mobile: "Enter valid 10-digit mobile number" });
            return;
        }
        dispatch(sendOtp(formData.mobile));
        setIsOtpSent(true);
    };

    const handleOTPChange = async (value) => {
        if (!isNaN(value)) {
            setOtp(value);
        }
    };

    const handleVerifyOtp = () => {
        if (otp.length === 4) {
            dispatch(verifyOtp(formData.mobile, otp));
        } else {
            setErrors({ otp: "Enter valid 4-digit OTP" });
        }
    };

    const handleResendOtp = () => {
        dispatch(resendOtp(formData.mobile));
    };

    const handleChangePassword = () => {
        if (!formData.password || formData.password.length < 8) {
            setErrors({ password: "Password must be at least 8 characters" });
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setErrors({ confirmPassword: "Passwords do not match" });
            return;
        }
        dispatch(changePassword(formData.mobile, formData.password));


    };
    useEffect(() => {
        if (changedPasswordStatus?.success) {
            swal.fire({
                show: true,
                title: "Great !",
                text: changedPasswordStatus?.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
            dispatch({ type: "RESET_DEFAULT" })
            navigate("/Login");
        }
    }, [changedPasswordStatus])
    return (
        <>
            <Header />
            <main className="block-main">
                <Container className='mt-4'>
                    <Row className="justify-content-center">
                        <Col md={6} lg={5}>
                            <Card className="bg-pattern">
                                <Card.Body className="p-4">
                                    <div className="text-center w-75 m-auto">
                                        <div className="auth-brand">
                                            <Link to="/" className="logo logo-dark text-center">
                                                <img src={LogoDark} alt="Logo Dark" height="40" />
                                            </Link>
                                            <Link to="/" className="logo logo-light text-center">
                                                <img src={LogoLight} alt="Logo Light" height="40" />
                                            </Link>
                                        </div>
                                        <p className="text-muted mb-4 mt-3">{t("Verify your mobile to change your password")}</p>
                                    </div>


                                    {step === 1 && (
                                        <>
                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                                <FormInput
                                                    label={t("Mobile")}
                                                    type="text"
                                                    errors={reduxErrors?.errors || errors}
                                                    name="mobile"
                                                    value={formData.mobile}
                                                    placeholder="Enter your Mobile"
                                                    onChange={selectMobileHandler}
                                                    containerClass={"mb-3 col-8"}
                                                    disabled={isOtpSent}
                                                />
                                                <div className="d-grid col-3">
                                                    <Button className='smp-round-btn ro-btn-theme' onClick={!isOtpSent ? handleSendOtp : handleResendOtp}>{!isOtpSent ? t("Send OTP") : t("Resend OTP")}</Button>
                                                </div>
                                            </div>
                                            {isOtpSent ? (
                                                <>
                                                    <div className="d-flex justify-content-between align-content-center mt-3">
                                                        <div>
                                                            <OtpInput
                                                                value={otp}
                                                                numInputs={4}
                                                                onChange={handleOTPChange}
                                                                separator={<span className="me-2 ms-2">*</span>}
                                                                inputStyle={{

                                                                    width: "50px",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ccc",
                                                                    height: "38px",
                                                                    margin: "0 5px"
                                                                }}
                                                                renderInput={(props) => <input {...props} />}
                                                            />
                                                            {(errors.otp || reduxErrors.otp) && (
                                                                <small className='text-danger'>{errors.otp || reduxErrors.otp}</small>
                                                            )}
                                                        </div>

                                                        <div className="d-flex justify-content-between col-3">
                                                            <Button className='smp-round-btn ro-btn-theme' onClick={handleVerifyOtp}>{t("Verify OTP")}</Button>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : ""}
                                        </>

                                    )}


                                    {step === 3 && (
                                        <>
                                            <FormInput
                                                label="New Password"
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={inputHandler}
                                                errors={errors || reduxErrors.errors}
                                                containerClass="mb-3"
                                            />
                                            <FormInput
                                                label="Confirm Password"
                                                type="password"
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={inputHandler}
                                                errors={errors || reduxErrors.errors}
                                                containerClass="mb-3"
                                            />
                                            {reduxErrors.message ? (<small className='text-danger'>{reduxErrors.message}</small>) : ""}
                                            <div className="d-grid justify-content-center">
                                                <Button className='smp-round-btn ro-btn-theme' onClick={handleChangePassword}>{t("Change Password")}</Button>
                                            </div>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </>
    );
}
